import React, { useEffect, useState } from "react";
import { TopBar } from "@/components/TopBar";
import { EmptyState } from "@/components/EmptyState";
import { useI18n } from "@/i18n";
import { useRouter } from "@/router/Router";
import { fetchOrders } from "@/lib/api";
import { formatOrderDate, formatUzs } from "@/lib/format";
import type { Order } from "@/types";
import { useBackButton } from "@/lib/hooks";

const STATUS_TONE: Record<Order["status"], "muted" | "success" | "accent"> = {
  new: "accent",
  confirmed: "accent",
  paid: "accent",
  preparing: "accent",
  ready_for_pickup: "success",
  handed_to_courier: "accent",
  delivered: "success",
  cancelled: "muted",
};

export function OrderHistoryPage() {
  const { t, locale } = useI18n();
  const { navigate, goBack } = useRouter();
  const [orders, setOrders] = useState<Order[]>([]);

  useEffect(() => {
    fetchOrders().then(setOrders);
  }, []);

  useBackButton(goBack);

  return (
    <>
      <TopBar title={t("orders.title")} onBack={goBack} />
      <main className="page page--no-nav">
        {orders.length === 0 ? (
          <EmptyState art="orders" title={t("orders.empty")} />
        ) : (
          orders.map((order) => (
            <button
              key={order.id}
              className="card"
              style={{ display: "block", width: "100%", textAlign: "left", padding: "var(--space-4)", marginBottom: 12 }}
              onClick={() => navigate({ name: "orderDetail", orderId: order.id })}
            >
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <span style={{ fontWeight: 700, fontSize: 14 }}>{order.number}</span>
                <span className={`badge badge--${STATUS_TONE[order.status]}`}>{t(`orders.status.${order.status}`)}</span>
              </div>
              <div style={{ fontSize: 12.5, color: "var(--color-ink-soft)", marginBottom: 8 }}>
                {formatOrderDate(order.createdAt, locale)} ·{" "}
                {order.items.map((i) => i.productName).join(", ")}
              </div>
              {order.status !== "cancelled" && order.paymentStatus === "pending" && order.paymentMethod !== "cash_on_pickup" && (
                <span className="badge badge--accent" style={{ marginBottom: 6 }}>{t("orders.paymentStatus.pending")}</span>
              )}
              <div className="price" style={{ fontSize: 15 }}>
                {formatUzs(order.totalUzs, locale)}
              </div>
            </button>
          ))
        )}
      </main>
    </>
  );
}
